import type { FC } from 'react';
import { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    container: {
      paddingHorizontal: 24,
      paddingBottom: 8,
      gap: 4
    },
    row: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      columnGap: 4
    },
    label: {
      color: theme.colors.onSurfaceVariant
    },
    value: {
      fontWeight: '700',
      color: theme.colors.onSurface
    }
  });

type Props = {
  senderLabel: string;
  senderName: string;
  visibleInLabel: string;
  visibleCountLabel: string;
};

export const OrganizationPostConfirmationContent: FC<Props> = ({
  senderLabel,
  senderName,
  visibleInLabel,
  visibleCountLabel
}) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <Text variant="bodyMedium" style={styles.label}>
          {senderLabel}
        </Text>
        <Text variant="bodyMedium" style={styles.value}>
          {senderName}
        </Text>
      </View>
      <View style={styles.row}>
        <Text variant="bodyMedium" style={styles.label}>
          {visibleInLabel}
        </Text>
        <Text variant="bodyMedium" style={styles.value}>
          {visibleCountLabel}
        </Text>
      </View>
    </View>
  );
};
